"use client";

import { ReactNode, useState } from "react";
import { cn } from "@/lib/utils";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
import { SliderWrapper } from "@/components/common/slider-wrapper";

export const CardSpecialGrid = ({
  items,
  activeIndex = 0,
  className,
}: {
  items: ReactNode[];
  activeIndex?: number;
  className?: string;
}) => {
  const [api, setApi] = useState<CarouselApi | null>(null);

  return (
    <div className={"@container my-6"}>
      <SliderWrapper api={api} activeIndex={activeIndex}>
        <Carousel
          opts={{
            skipSnaps: true,
          }}
          setApi={setApi}
          plugins={[WheelGesturesPlugin()]}
        >
          <CarouselContent>
            {items.map((item, index) => (
              <CarouselItem
                className={cn("grid basis-[280px] md:basis-[384px]", className)}
                key={index}
                isFirst={index === 0}
                isLast={index === items.length - 1}
              >
                {item}
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
      </SliderWrapper>
    </div>
  );
};
